import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ProjecaoMensalService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'projecao-mensal/excel/deletar', 'excelProjecaoMensalDeletar');
    },
    enviarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'projecao-mensal/excel', 'excelProjecaoInccIpca');
    },
    obterExcel(): Promise<void | AxiosResponse<any>>
    {
        return Client.getBlob('projecao-mensal/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('projecao-mensal/eventGrid', {});
    }
}

export default ProjecaoMensalService;